import mycfg from '@/config' 
import dd from 'dingtalk-jsapi'

export default {
    name: "DDHelper",

    selectDepartment(limit = 1) {

        return new Promise((resolve, reject) => {

            dd.biz.contact.departmentsPicker({
                title:"选择部门",            //标题
                corpId:mycfg.dd.corpId,              //企业的corpId
                multiple:true,            //是否多选
                limitTips:"超出了",          //超过限定人数返回提示
                maxDepartments:limit,            //最大选择部门数量
                pickedDepartments:[],          //已选部门
                disabledDepartments:[],        //不可选部门
                requiredDepartments:[],        //必选部门（不可取消选中状态）
                appId:mycfg.dd.agentId,              //微应用的Id
                permissionType:"GLOBAL",          //选人权限，目前只有GLOBAL这个参数
                onSuccess: function(result) {
                    /**
                    {
                        userCount:1,                              //选择人数
                        departmentsCount:1，//选择的部门数量
                        departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
                    }
                    */
                    if (result.departmentsCount > 0) {
                        resolve(result.departments)
                    } else {
                        resolve([])
                    }
                },
                onFail : function(err) {
                    console.log(`searchDepartment: ${err}`)
                    reject(err)
                }
            })
        })
    },

    selectUser(limit = 1, selectedUsers = []) {
        return new Promise((resolve, reject) => {
            dd.biz.contact.choose({
                multiple: true, //是否多选：true多选 false单选； 默认true
                users: selectedUsers, //默认选中的用户列表，员工userid；成功回调中应包含该信息
                corpId: mycfg.dd.corpId, //企业id
                max: limit, //人数限制，当multiple为true才生效，可选范围1-1500
                onSuccess: function(data) {
                /* data结构
                [{
                    "name": "张三", //姓名
                    "avatar": "
            http://g.alicdn.com/avatar/zhangsan.png
            " //头像图片url，可能为空
                    "emplId": '0573', //员工userid
                },
                ...
                ]
                */
                    resolve(data.map(user => ({userid:user.emplId, username:user.name, ...user})))
                },
                onFail : function(err) {
                    console.log(`select user:${err}`)
                    reject(err)
                }
            })        
        })
    },

    selectDepartmentAndUser(limit = 100) {
        return new Promise((resolve, reject)=>{
            dd.biz.contact.complexPicker({
                title:"请选择部门和部门成员",            //标题
                corpId:mycfg.dd.corpId,              //企业的corpId
                multiple:true,            //是否多选
                limitTips:"超出了",          //超过限定人数返回提示
                maxUsers:limit,            //最大可选人数
                pickedUsers:[],            //已选用户
                pickedDepartments:[],          //已选部门
                disabledUsers:[],            //不可选用户
                disabledDepartments:[],        //不可选部门
                requiredUsers:[],            //必选用户（不可取消选中状态）
                requiredDepartments:[],        //必选部门（不可取消选中状态）
                appId:mycfg.dd.agentId,              //微应用Id，企业内部应用查看AgentId
                permissionType:"GLOBAL",          //可添加权限校验，选人权限，目前只有GLOBAL这个参数
                responseUserOnly:false,        //返回人，或者返回人和部门
                startWithDepartmentId:0 ,   //仅支持0和-1
                onSuccess: function(result) {
                    /**
                    {
                        selectedCount:1,                              //选择人数
                        users:[{"name":"","avatar":"","userid":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
                        departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
                    }
                    */
                   const res = {
                       ...result,
                       users:result.users.map(user=>({...user, userid:user.emplId}))
                   }
                   console.log(`selectDepartmentAndUser:${JSON.stringify(res)}`)
                   resolve(res)
                },
               onFail : function(err) {
                   reject(err)
               }
            })
        })
    }
}